module.exports = __webpack_public_path__ + "static/media/the-long-way-to-a-small-angry-planet.ace07e87.jpg";